/* c8 ignore start */
import customers from "./customers";
import cards from "./cards";

export default {
  customers,
  cards,
};
/* c8 ignore end */
